import React, { useEffect, useMemo, useState } from "react";
import Breadcrumb from "../utlis/Breadcrumb";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import { getEventsinner } from "../Service/Api.js";

function Events() {
  const [eventsData, setEventsData] = useState([]);
  const [selectedYear, setSelectedYear] = useState("All");
  const [selectedMonth, setSelectedMonth] = useState("All");
  const [search, setSearch] = useState("");

  const BASE_URL = "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/";

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const res = await getEventsinner();

        const formatted = res.map((item) => {
          const rawDate = item.date || item.isoDate || item.eventDate;
          const date = rawDate ? new Date(rawDate) : new Date();

          return {
            ...item,
            src: item.images?.[0] ? BASE_URL + item.images[0] : "",
            year: date.getFullYear().toString(),
            month: (date.getMonth() + 1).toString(),
            dateText: date.toLocaleDateString("en-GB"),
          };
        });

        setEventsData(formatted);

        const years = [...new Set(formatted.map((i) => i.year))].sort(
          (a, b) => b - a,
        );

        if (years.length > 0) {
          setSelectedYear(years[0]);
        }
      } catch (err) {
        console.error("Events API error:", err);
      }
    };

    fetchEvents();
  }, []);

  const uniqueYears = useMemo(() => {
    return [...new Set(eventsData.map((i) => i.year))].sort((a, b) => b - a);
  }, [eventsData]);

  const filteredEvents = useMemo(() => {
    return eventsData.filter((item) => {
      const yearMatch = selectedYear === "All" || item.year === selectedYear;

      const monthMatch =
        selectedMonth === "All" || item.month === selectedMonth;

      const searchMatch =
        item.title?.toLowerCase().includes(search.toLowerCase()) ||
        item.description?.toLowerCase().includes(search.toLowerCase());

      return yearMatch && monthMatch && searchMatch;
    });
  }, [eventsData, selectedYear, selectedMonth, search]);

  return (
    <>
      {/* ================= HEADER ================= */}
      <Header />
      <div className="InnerSld">
        <Breadcrumb
          img="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/page-title.jpg"
          title="Inner "
          title2="Events"
          parentTitle="Events"
          path="Inner Events"
        />
      </div>

      <div className="innerbody">
        <div className="container-fluid">
          <div className="row tabs-dynamics mt-3">
            <div className="col-lg-3 col-md-6 col-12">
              <div className="filter-card count-card mb-2">
                <p>
                  Total Count <span>{filteredEvents.length}</span>
                </p>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 col-12">
              <div className="filter-card h-100">
                <select
                  className="form-select filter-select"
                  value={selectedYear}
                  onChange={(e) => setSelectedYear(e.target.value)}
                >
                  <option value="All">All Years</option>
                  {uniqueYears.map((year) => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 col-12">
              <div className="filter-card h-100">
                <select
                  className="form-select filter-select"
                  value={selectedMonth}
                  onChange={(e) => setSelectedMonth(e.target.value)}
                >
                  <option value="All">All Months</option>
                  {Array.from({ length: 12 }, (_, i) => (
                    <option key={i + 1} value={(i + 1).toString()}>
                      {new Date(0, i).toLocaleString("en-US", {
                        month: "short",
                      })}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 col-12">
              <div className="filter-card h-100">
                <input
                  type="text"
                  className="form-control filter-input"
                  placeholder="Search Events..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>
            </div>
          </div>

          <div className="row mt-4">
            {filteredEvents.length > 0 ? (
              filteredEvents
                .sort(function (a, b) {
                  return new Date(b.date) - new Date(a.date);
                })
                .map((item) => (
                  <div key={item._id} className="col-12 mb-4">
                    <div className="news-card">
                      <span className="news-date">{item.dateText}</span>

                      <div className="news-body">
                        <h3>{item.title}</h3>
                        <p>{item.description}</p>

                        {/* <div className="d-flex flex-wrap gap-3 mt-3">
                          {item.venue && (
                            <span className="attachment">
                              <i className="bi bi-geo-alt-fill"></i>
                              {item.venue}
                            </span>
                          )}

                          {item.time && (
                            <span className="attachment">
                              <i className="bi bi-clock-fill"></i>
                              {item.time}
                            </span>
                          )}
                        </div> */}
                      </div>
                    </div>
                  </div>
                ))
            ) : (
              <div className="col-12 text-center">
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXCKWB/public/images/dummy.jpg"
                  alt="No Events"
                  className="img-fluid"
                />
                <h5 className="mt-3">No Events Found</h5>
              </div>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Events;
